import { createContext } from "react";
import type { PresenceByApplication } from "./useLivePresence";

/** Presence by application id for list pages (see useLivePresence). */
export const LivePresenceContext = createContext<PresenceByApplication>(
  new Map()
);
